// extracted by mini-css-extract-plugin
module.exports = {"Button":"css-modules_Button__8BBfy"};